incomingValue